export const DEFAULT_SEMESTER = "FA26";